// Vaelger brandprofil ud fra REACT_APP_BRAND paa build-tidspunktet.
//
// Craco baelger vaerdien ind i JavaScript'en naar der bygges, praecis som
// REACT_APP_BACKEND_URL. Et build er derfor bundet til ét brand — det er med
// vilje: en runtime-omskiftning ville betyde at begge brands' tekster og
// farver skulle sendes til alle brugere.

import hentpost from './hentpost';
import digitalbox from './digitalbox';

const PROFILER = { hentpost, digitalbox };

const valgt = (process.env.REACT_APP_BRAND || 'hentpost').trim().toLowerCase();

if (!PROFILER[valgt]) {
    // Fejl haardt frem for at falde tilbage. En tavs fallback ville sende et
    // DigitalBox-build i luften med hentpost-logo og -tekster.
    throw new Error(
        `Ukendt REACT_APP_BRAND=${valgt}. Gyldige vaerdier: ${Object.keys(PROFILER).join(', ')}`
    );
}

const BRAND = PROFILER[valgt];

// Sitets egen oprindelse. I denne opsaetning serverer nginx frontend og API
// fra samme host, saa backend-URL'en er ogsaa sitets offentlige adresse.
// Det giver rigtige links paa dev i stedet for links til produktion.
export const BASE_URL = (
    process.env.REACT_APP_BACKEND_URL || `https://${BRAND.domain}`
).replace(/\/+$/, '');

/** Bilagsindbakkens adresse for et CVR-nummer: cvr12345678@<maildomaene> */
export const inboxEmail = (cvr) => `cvr${cvr}@${BRAND.mailDomain}`;

/** Modtage-endpoint et selskab peger sin Digital Post-videresendelse paa. */
export const inboxEndpoint = (companyId) => `${BASE_URL}/api/inbox/${companyId}`;

export default BRAND;
